<page-load-header *ngIf="!initialized && !this.auth"></page-load-header>

<div>
  <div *ngIf="!auth.isLoggedIn()" class="row no-gutters no-candidates" style="height: 300px">
    <div class="col-sm-12 my-auto">
      <h1><i class="fas fa-empty-set"></i></h1>
      <h4>You are not logged in.</h4>
      <p>Please login or create an account to add a poster.</p>
      <button class="btn btn-instagram" (click)="nav.showLogin()" type="submit">Login/Sign Up</button>
    </div>
  </div>

  <div *ngIf="initialized && auth.isLoggedIn()" class="container">
    <div class="row mb-5 mt-2">
      <div class="col-md-12">
        <form class="form" [formGroup]="formGroup" (ngSubmit)="onSave()" novalidate>
          <div class="row mb-3">
            <div class="col-sm-6 pull-right">
              <h3>Call For Posters</h3>
            </div>
            <div class="col-sm-6 text-right pull-right">
              <button (click)="navigateBack()" class="btn btn-outline-dark mr-1" type="button">Cancel</button>
              <button class="btn btn-primary" [promiseBtn]="submitComplete" type="submit">Save</button>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12 mb-5">
              <div class="row mb-2">
                <div class="col-md-12">
                  <label for="firstName">Conference</label>
                  <select (change)="conferenceChange($event)" class="form-control" formControlName="conferenceId">
                    <option value="">Please Choose...</option>
                    <ng-container *ngFor="let conference of conferences">
                      <option *ngIf="conference.showPosters" value="{{ conference.id }}">{{ conference.name }}</option>
                    </ng-container>
                  </select>
                  <div class="invalid-message">
                    <div>Conference is required</div>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-12">
                  <div *ngIf="formGroup.controls['conferenceId'].value == 15" class="alert alert-warning">
                    <strong> Poster Abstract Submissions</strong>

                    <p>A Poster is a visual display of a presentation organized around an empirical, conceptual, methodological, historical, or practical theme. Submissions are considered for acceptance based on topic relevance, alignment with the science of behavior analysis, and adherence to all submission guidelines. Submission deadline: Monday, February 8th.</p>

                    <strong>Poster Submission Details</strong>

                    <p>Abstract: The abstract must follow American Psychological Association style guidelines and be no fewer than 150 words and no more than 200 words. Abstracts should clearly identify how the Poster aligns with the Program Area that you have selected (e.g. Autism, OBM, Diversity, etc.). Abstracts should begin with a sentence stating why the topic is important and end with the general conclusion, relevance, or potential impact. All acronyms must be spelled out at first mention.</p>

                    <p>Note for Data-Based Poster Presentation: The abstract for a data-based Poster presentation also must include (1) an overview of the types of participants, (2) an overview of the types of procedures, and (3) a statement of outcomes. Supporting Graph or Table: Data-based submissions must include a graphic or tabular summary of obtained data. Data-based submissions without a supporting graph or table will be rejected. The data does not need to be complete at time of submission, but the abstract and graph/table must establish that the project is well under way. Graphs and tables submitted must be of professional quality and formatted according to APA Style.</p>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-12">
                  <label for="firstName">Poster Session</label>
                  <select class="form-control" formControlName="posterSessionId">
                    <option *ngFor="let session of sessions" value="{{ session.id }}">{{ session.dateTime | date: 'medium' }} {{ session.dateTime | timezone }}</option>
                  </select>
                  <div class="invalid-message">
                    <div>Poster Session is required</div>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-12">
                  <label for="firstName">Poster Title</label>
                  <input type="text" class="form-control" formControlName="title" />
                  <div class="invalid-message">
                    <div>Title is required</div>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-12">
                  <label for="firstName">Received IRB Approval?</label>
                  <select class="form-control" formControlName="irbApproval">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                  <div class="invalid-message">
                    <div>Title is required</div>
                  </div>
                </div>
              </div>
              <h5>Primary Presenter</h5>
              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="firstName">First Name</label>
                  <input type="text" class="form-control" disabled [readOnly] [value]="auth.user.firstName" />
                  <div class="invalid-message">
                    <div>Name is required</div>
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="firstName">Last Name</label>
                  <input type="text" class="form-control" disabled [readOnly] [value]="auth.user.lastName" />
                  <div class="invalid-message">
                    <div>Name is required</div>
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="firstName">Email</label>
                  <input type="text" class="form-control" disabled [readOnly] [value]="auth.user.email" />
                  <div class="invalid-message">
                    <div>Email is required</div>
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="firstName">Affiliation</label>
                  <input type="text" class="form-control" formControlName="affiliation" />
                  <div class="invalid-message">
                    <div>Affiliation is required</div>
                  </div>
                </div>
              </div>
              <h5>Additional Presenters</h5>
              <div formArrayName="additionalAuthors" *ngFor="let question of formGroup.controls.additionalAuthors['controls']; let i = index" class="row mb-2">
                <ng-container [formGroupName]="i">
                  <div class="col-md-3">
                    <label for="firstName">First Name</label>
                    <input type="text" class="form-control" formControlName="firstName" />
                    <div class="invalid-message">
                      <div>Name is required</div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label for="firstName">Last Name</label>
                    <input type="text" class="form-control" formControlName="lastName" />
                    <div class="invalid-message">
                      <div>Name is required</div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label for="firstName">Email</label>
                    <input type="text" class="form-control" formControlName="email" />
                    <div class="invalid-message">
                      <div>Email is required</div>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <label for="firstName">Affiliation</label>
                    <input type="text" class="form-control" formControlName="affiliation" />
                    <div class="invalid-message">
                      <div>Affiliation is required</div>
                    </div>
                  </div>
                  <div class="form-group col-md-1 mt-auto mb-0">
                    <label for="inputZip">&nbsp;</label>
                    <button type="button" class="btn btn-icon btn-danger transition-3d-hover" (click)="removeRegistrant(i)">
                      <span class="fas fa-trash btn-icon__inner"></span>
                    </button>
                  </div>
                </ng-container>
              </div>
              <a role="button" class="text-primary cursor-pointer" (click)="addRegistrant()">Add</a>
              <!-- <div class="row">
                <div class="col-md-12">
                  <label for="firstName">Additional Presenters (Comma separated emails)</label>
                  <input type="text" class="form-control" formControlName="additionalPresenters" />
                  <div class="invalid-message">
                    <div>First Name is required</div>
                  </div>
                </div>
              </div> -->
              <hr />
              <div class="row">
                <div class="col-md-12">
                  <label for="zip">Description/Abstract</label>
                  <kendo-editor formControlName="description"></kendo-editor>
                  <div class="invalid-message">
                    <div>Description is required</div>
                  </div>
                </div>
              </div>
              <div class="row mt-5">
                <div class="col">
                  <h4>Supporting Documents</h4>
                  <div class="alert alert-warning">Please upload any supporting data and related documents.</div>
                </div>
              </div>
              <div formArrayName="materials" *ngFor="let benefit of formGroup.controls.materials['controls']; let i = index">
                <div [formGroupName]="i" class="row">
                  <div class="col-md-3 mb-3">
                    <label for="firstName">Description</label>
                    <i class="fa fa-asterisk"></i>
                    <input type="text" class="form-control" formControlName="description" />
                    <div class="invalid-message">
                      <div>Description is required</div>
                    </div>
                  </div>
                  <div class="col-md-3 mb-3">
                    <label for="country">File Type</label>
                    <i class="fa fa-asterisk"></i>
                    <select class="form-control" formControlName="fileType">
                      <option value="">Please Choose...</option>
                      <option *ngFor="let item of FileTypeEnum | keyvalue" value="{{ item.key }}">{{ item.value }}</option>
                    </select>
                    <div class="invalid-message">
                      <div>File Type is required</div>
                    </div>
                  </div>
                  <div id="exhibitUpload" class="col-md-4 mb-3">
                    <label for="country">File</label>
                    <i class="fa fa-asterisk"></i>
                    <kendo-upload [saveUrl]="uploadUrl" [multiple]="false" (success)="successEventHandler($event, i)"></kendo-upload>
                    <div class="invalid-message">
                      <div>File is required</div>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="country">&nbsp;</label>
                    <button type="button" class="d-block btn btn-icon btn-danger transition-3d-hover" (click)="removeMaterial(i)">
                      <span class="fas fa-trash btn-icon__inner"></span>
                    </button>
                  </div>
                </div>
              </div>
              <a role="button" class="text-primary cursor-pointer" (click)="addMaterial()">Add a file</a>
              <hr />
              <div class="row mt-5">
                <div class="col">
                  <label class="d-block">Please upload a jpg or png file of your poster at least 5000px x 5000px</label>
                  <button type="button" (click)="editImage(content)" class="btn btn-sm btn-primary transition-3d-hover mb-1 mr-2 mb-sm-0">Upload Poster</button>
                </div>
                <div class="col">
                  <label class="d-block">Thumbnail</label>
                  <button type="button" (click)="editThumbnailImage(contentThumb)" class="btn btn-sm btn-primary transition-3d-hover mb-1 mr-2 mb-sm-0">Upload Thumbnail</button>
                </div>
              </div>
            </div>
            <div class="col-lg-12 text-left">
              <img *ngIf="poster.posterAssetPath && !croppedImage" class="img-fluid" style="max-height: 400px" src="fetchImage?filename={{ poster.posterAssetPath }}"  />
              <img *ngIf="croppedImage" class="img-fluid" style="max-height: 600px" [src]="croppedImage"  />
              <img *ngIf="!croppedImage && !poster.posterAssetPath" class="img-fluid" src="../../../assets/poster-placeholder.png" />
            </div>
          </div>

          <!-- End My Network -->
        </form>
      </div>
    </div>

    <ng-template #content let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Edit Image</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="col-md-12 text-center">
          <label class="btn-bs-file btn btn-lg btn-primary">
            Choose an Image
            <input type="file" (change)="fileChangeEvent($event)" />
          </label>

          <image-cropper [imageChangedEvent]="imageChangedEvent" [imageBase64]="initialCroppedImage" [maintainAspectRatio]="false" [onlyScaleDown]="true" format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (loadImageFailed)="loadImageFailed()"></image-cropper>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Save</button>
      </div>
    </ng-template>

    <ng-template #contentThumb let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Edit Thumbnail</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="col-md-12 text-center">
          <label class="btn-bs-file btn btn-lg btn-primary">
            Choose an Image
            <input type="file" (change)="fileChangeEventThumb($event)" />
          </label>

          <image-cropper [imageChangedEvent]="imageChangedEventThumb" [imageBase64]="initialCroppedImageThumb" [maintainAspectRatio]="false" [onlyScaleDown]="true" format="png" (imageCropped)="imageCroppedThumb($event)" (imageLoaded)="imageLoadedThumb()" (loadImageFailed)="loadImageFailedThumb()"></image-cropper>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Save</button>
      </div>
    </ng-template>
  </div>
</div>
